"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebtPaymentStrategy = exports.DebtTaxComputationStrategy = exports.DTICalculationStrategy = void 0;
/**
 * Strategy for calculating DTI.
 * See: https://github.com/heraclescorp/heracles/pull/50630
 * Default strategy is the logic BEFORE this PR was merged.
 * AVOID_EXCEEDING_DTI_CAP_V1 strategy is the logic AFTER this PR was merged.
 * @TranslateToPython
 */
var DTICalculationStrategy;
(function (DTICalculationStrategy) {
    /** Calculate DTI, rounding to six decimal places.
     * When computing prelineDTI, round grossMonthlyIncome to nearest even number with 2 decimal places.
     * prelineDTI is rounded up to 6 decimal places
     */
    DTICalculationStrategy["DEFAULT"] = "DEFAULT";
    /**
     * When computing preLineDTI, round grossMonthlyIncome down to 2 decimal places to be more conservative in producing larger prelineDTI.
     * Round payments UP to 2 decimal places - this was done to be more conservative in producing larger postlineDTI, but
     * unintentionally resulted in some LAs breaching the postline DTI cap.
     * prelineDTI is rounded up to 4 decimal places to be more conservative in producing larger postlineDTI.
     */
    DTICalculationStrategy["AVOID_EXCEEDING_DTI_CAP_V1"] = "AVOID_EXCEEDING_DTI_CAP_V1";
    /**
     * Following changes are made to avoid false positives where DTI caps are exceeded due to limited precision.
     * Round payments DOWN to 12 decimal places for higher precision to avoid breaching postline DTI cap.
     * When computing prelineDTI, still round grossMonthly income down to 2 decimal places.
     * prelineDTI is still rounded up to 4 decimal places like the previous strategy.
     */
    DTICalculationStrategy["AVOID_EXCEEDING_DTI_CAP_V2"] = "AVOID_EXCEEDING_DTI_CAP_V2";
})(DTICalculationStrategy || (exports.DTICalculationStrategy = DTICalculationStrategy = {}));
/**
 * Strategy for computing debt payments in DTI calculation.
 * @TranslateToPython
 */
var DebtTaxComputationStrategy;
(function (DebtTaxComputationStrategy) {
    /**
     * Include property tax and insurance in debt payments for DTI calculation.
     */
    DebtTaxComputationStrategy["INCLUDE_PROPERTY_TAX_INSURANCE"] = "INCLUDE_PROPERTY_TAX_INSURANCE";
    /**
     * Exclude monthly payments only if source matches, i.e. tradelineMonthlyPayment
     */
    DebtTaxComputationStrategy["EXCLUDE_MONTHLY_PAYMENTS_ONLY_IF_SOURCE_MATCH"] = "EXCLUDE_MONTHLY_PAYMENTS_ONLY_IF_SOURCE_MATCH";
    /**
     * Exclude attested no second lien from debt payments for DTI calculation.
     */
    DebtTaxComputationStrategy["EXCLUDE_ATTESTED_NO_SECOND_LIEN"] = "EXCLUDE_ATTESTED_NO_SECOND_LIEN";
})(DebtTaxComputationStrategy || (exports.DebtTaxComputationStrategy = DebtTaxComputationStrategy = {}));
/**
 * Strategy for computing non-tax debt payments in DTI calculation.
 * @TranslateToPython
 */
var DebtPaymentStrategy;
(function (DebtPaymentStrategy) {
    /**
     * Include stated monthly rent payment in debt payments for DTI calculation.
     */
    DebtPaymentStrategy["INCLUDE_STATED_MONTHLY_RENT"] = "INCLUDE_STATED_MONTHLY_RENT";
})(DebtPaymentStrategy || (exports.DebtPaymentStrategy = DebtPaymentStrategy = {}));
